export const ASSIGNEE_ENTITY_KEYS = {
  ID: 'id',
  ACCOUNT_ID: 'accountId',
  USER_ACCOUNT_ID: 'userAccountId',
  AVATAR_URL: 'avatarUrl',
  USER_AVATAR_URL: 'userAvatarUrl',
  NAME: 'name',
  USER_NAME: 'userName',
  DISPLAY_NAME: 'displayName',
  EMAIL: 'email',
  ROLE_ID: 'roleId',
  ADMIN_ROLE_ID: 'adminRoleId',
  WORKSPACE_IDS: 'workspaceIds'
}

export const INTERVAL_ENTITY_KEYS = {
  ID: 'id',
  NAME: 'name'
}

export const OKR_LEVEL_ENTITY_KEYS = {
  ID: 'id',
  NAME: 'name',
  WORKSPACES: 'workspaces',
  PREFIX: 'prefix',
  COLOR: 'color',
  ORDER_VALUE: 'orderValue',
  LEVEL_ID: 'levelId',
  TYPE_ID: 'typeId',
  FIELD_TYPE_IDS: 'fieldTypeIds',
  ALLOW_WITHOUT_PARENT: 'allowWithoutParent'
}

export const OKR_ELEMENT_ENTITY_KEYS = {
  WORKSPACE_ID: 'workspaceId',
  ID: 'id',
  OWNER_ID: 'ownerId',
  STAKEHOLDERS: 'stakeholders',
  GROUPS: 'groups',
  NAME: 'name',
  CONFIDENCE_LEVEL_ID: 'confidenceLevelId',
  TYPE_ID: 'typeId',
  PERMISSIONS: 'permissions',
  CHILD_COUNT: 'childCount',
  WEIGHT: 'weight',
  WEIGHT_MULTIPLIER: 'weightMultiplier',
  ACTIVE_TARGET: 'activeTarget',
  LAST_GRADE_UPDATE_DATE: 'lastGradeUpdateDate',
  VISIBLE_COUNT: 'visibleCount',
  EXPANDED: 'expanded',
  HIDDEN_BY_FILTER: 'hiddenByFilter',
  FIT_FILTER_CRITERIA: 'fitFilterCriteria',
  PROGRESS_DATA: 'progressData',
  ORDER_VALUE: 'orderValue'
}

export const GROUP_ENTITY_KEYS = {
  ID: 'id',
  NAME: 'name',
  DESCRIPTION: 'description',
  ICON: 'icon',
  COLOR: 'color',
  PARENT_ID: 'parentId',
  WORKSPACES: 'workspaces',
  USER_COUNT: 'userCount',
  CHILD_COUNT: 'childCount',
  ASSOCIATED_PLATFORM_GROUPS: 'associatedPlatformGroups'
}

export const REQUEST_ENTITY_KEYS = {
  ACCOUNT_IDS: 'accountIds',
  GROUP_IDS: 'groupIds',
  REQUIRED_USERS_ACCOUNT_IDS: 'requiredUserAccountIds',
  REQUIRED_WORKSPACE_IDS: 'requiredWorkspaceIds',
  WORKSPACE_IDS: 'workspaceIds',
  GROUP_ID: 'groupId',
  PARENT_GROUP_ID: 'parentGroupId',
  SEARCH_STRING: 'searchString',
  SEARCH_TYPE_ID: 'searchTypeId',
  LIMIT: 'limit',
  START_AT: 'startAt',
  SYNCED: 'synced',
  ADD_TO_ALL_WORKSPACES: 'addToAllWorkspaces',
  OPERATOR_TYPE_ID: 'operatorTypeId',
  VALUE: 'value',
  FIELD_ID: 'fieldId',
  FIELD_TYPE_ID: 'fieldTypeId',
  IDENTIFIER: 'identifier',
  IDENTIFIER_TYPE_ID: 'identifierTypeId',
  WORKSPACE_ID: 'workspaceId',
  EXPAND_ALL: 'expandAll',
  TYPE_IDS: 'typeIds',
  VIEW_CONFIG: 'viewConfig'
}

export const WORKSPACE_ENTITY_KEYS = {
  ID: 'id',
  NAME: 'name',
  DESCRIPTION: 'description',
  KEY: 'key',
  PUBLIC: 'public',
  TIMEZONE: 'timezone',
  COLOR: 'color',
  LEVELS: 'levels',
  WORKSPACE_ID: 'workspaceId',
  ORDER: 'order'
}

export const LABEL_ENTITY_KEYS = {
  ID: 'id',
  NAME: 'name'
}

export const TARGET_PERIOD_ENTITY_KEYS = {
  ID: 'id',
  VALUE: 'value',
  INNER_DATE: 'innerDate',
  TARGET_VALUE: 'targetValue',
  START_DATE: 'startDate',
  ACTUAL_START_DATE: 'actualStartDate',
  END_DATE: 'endDate',
  ACTUAL_END_DATE: 'actualEndDate',
  YEAR: 'year',
  MONTH: 'month',
  NAME: 'name',
  THRESHOLD: 'threshold'
}

export const COMPANY_SETTINGS_ENTITY_KEYS = {
  ALLOW_WS_ADMIN_TO_SEE_PRIVATE_OBJECTIVES: 'allowWsAdminToSeePrivateObj',
  ALLOW_MANAGE_GROUPS_FOR_WS_ADMINS: 'allowManageGroupsForWsAdmins',
  SHOW_CUSTOM_DASHBOARD_TO_USERS: 'showCustomDashboardForUsers',
  SHOW_GENERAL_DASHBOARD_TO_USERS: 'showGeneralDashboardForUsers',
  SHOW_PERFORMANCE_DASHBOARD_TO_USERS: 'showPerformanceReportForUsers',
  HIDE_OTHER_USERS_AND_GROUPS_ON_HOMEPAGE: 'hideOtherUsersAndGroupsOnHomepage',
  OBJECTIVE_CONTRIBUTE_BY_DEFAULT: 'objectiveContributeByDefault',
  TASK_CONTRIBUTE_BY_DEFAULT: 'taskContributeByDefault',
  ALLOW_LABEL_CREATION: 'allowLabelCreation',
  USER_ROLE_BY_DEFAULT: 'userRoleByDefault',
  THRESHOLD_BEHIND: 'thresholdBehind',
  THRESHOLD_ON_TRACK: 'thresholdOnTrack',
  TRACING_DISABLED: 'tracingDisabled',
  HIDE_OBJECTIVE_OWNER: 'hideObjectiveOwner',
  SHOW_CHECKINS_FEED_FOR_USERS: 'showCheckinsFeedForUsers',
  MCP_ENABLED: 'mcpEnabled'
}

const KEY_NAME = 'keyName'
const KEY_ID = 'keyId'

const CUSTOM_FIELD_ENTITY_KEYS_PARAMS = {
  ID: {
    [KEY_NAME]: 'id'
  },
  ICON: {
    [KEY_NAME]: 'icon'
  },
  NAME: {
    [KEY_NAME]: 'name',
    [KEY_ID]: 1
  },
  TYPE: {
    [KEY_NAME]: 'type'
  },
  TYPE_ID: {
    [KEY_NAME]: 'typeId'
  },
  ELEMENT_TYPE_IDS: {
    [KEY_NAME]: 'elementTypeIds'
  },
  WORKSPACES: {
    [KEY_NAME]: 'workspaces'
  },
  WORKSPACE_IDS: {
    [KEY_NAME]: 'workspaceIds'
  },
  ORDER_VALUE: {
    [KEY_NAME]: 'orderValue',
    [KEY_ID]: 2
  },
  ACTIVE: {
    [KEY_NAME]: 'active',
    [KEY_ID]: 3
  },
  REQUIRED: {
    [KEY_NAME]: 'required',
    [KEY_ID]: 4
  },
  FILTERABLE: {
    [KEY_NAME]: 'filterable',
    [KEY_ID]: 5
  },
  SORTABLE: {
    [KEY_NAME]: 'sortable',
    [KEY_ID]: 6
  },
  HELP_TEXT: {
    [KEY_NAME]: 'helpText',
    [KEY_ID]: 9
  },
  PLACEMENT: {
    [KEY_NAME]: 'placement'
  },
  OPTIONS: {
    [KEY_NAME]: 'options'
  },
  CURRENCY: {
    [KEY_NAME]: 'currency'
  },
  ADDITIONAL_PARAMETERS: {
    [KEY_NAME]: 'additionalParameters'
  },
  ADDITIONAL_FIELDS: {
    [KEY_NAME]: 'additionalFields'
  },
  DISPLAY_NAME: {
    [KEY_NAME]: 'displayName'
  },
  DEFAULT_WIDTH: {
    [KEY_NAME]: 'defaultWidth'
  },
  MIN_WIDTH: {
    [KEY_NAME]: 'minWidth'
  },
  HAS_TABLE_COLUMN: {
    [KEY_NAME]: 'hasTableColumn'
  },
  DEFAULT_VALUE: {
    [KEY_NAME]: 'defaultValue'
  }
}
export const CUSTOM_FIELD_ENTITY_KEYS = Object.entries(CUSTOM_FIELD_ENTITY_KEYS_PARAMS).reduce(
  (acc, [key, value]) => {
    return {
      ...acc,
      [key]: value[KEY_NAME]
    }
  },
  {}
)
export const CUSTOM_FIELD_ENTITY_KEYS_IDS = Object.entries(CUSTOM_FIELD_ENTITY_KEYS_PARAMS).reduce(
  (acc, [key, value]) => {
    if (!value[KEY_ID]) {
      return acc
    }
    return {
      ...acc,
      [key]: value[KEY_ID]
    }
  },
  {}
)

export const STATUS_NAMES_ENTITY_KEYS = {
  STATUS_ID: 'statusId',
  DEFAULT_NAME: 'defaultName',
  CUSTOMER_NAME: 'customerName',
  TRANSLATION_KEYS: 'translationKeys',
  KEY: 'key',
  TEMPLATE: 'template',
  I18N_CONTEXT: 'i18nContext',
  DEFAULT_TEMPLATE: 'defaultTemplate'
}

export const WEB_APP_ENTITY_KEYS = {
  ID: 'id',
  PLATFORM_IDS: 'platformIds'
}

export const OKR_BULK_UPDATE_ENTITY_KEYS = {
  OPERATION: 'operation',
  OPERATION_ID: 'operationId',
  VALUE_KEY: 'valueKey',
  LABEL_KEY: 'labelKey',
  CORE_FIELDS: 'coreFields',
  CUSTOM_FIELDS: 'customFields',
  FIELD_ID: 'fieldId',
  DISABLED: 'disabled',
  NAME: 'name',
  VALUE: 'value',
  NEW_VALUE: 'newValue'
}

export const SCHEDULE_ENTITY_KEYS = {
  NAME: 'name',
  PARAMS: 'params',
  FREQUENCY_TYPE_ID: 'frequencyTypeId',
  START_FROM: 'startFrom',
  MONTH_DAY: 'monthDay',
  GROUP_IDS: 'groupIds',
  TYPE_ID: 'typeId',
  ID: 'id',
  VALUE: 'value',
  FREQUENCIES_IDS: 'value',
  SEARCH_STRING: 'searchString',
  SHORT_NAME: 'shortName',
  REMINDERS: 'reminders',
  NOTIFICATION_CHANNEL_IDS: 'notificationChannels',
  WEEK_DAY_ID: 'weekDayId',
  WEEK_DAY_NTH_NUMBER: 'weekDayNthNumber',
  REPEAT_FREQUENCY: 'repeatFrequency',
  WEEK_DAY_IDS: 'weekDayIds',
  PARTICIPANTS: 'participants'
}

export const SCHEDULE_FREQUENCY_INNER_PARAMS_ENTITY_KEYS = {
  WEEKDAY: 'weekday',
  NTH_WEEKDAY: 'nthWeekday',
  REPEAT_INTERVAL: 'repeatInterval',
  REPEAT_UNIT: 'repeatUnit',
  WEEKDAYS: 'weekdays',
  MONTH_DAY: 'monthDay'
}

export const REMINDER_ENTITY_KEYS = {
  ID: 'id',
  DAYS_SHIFT: 'daysShift',
  MINUTES: 'timeInMinutes',
  TIMEZONE_ID: 'timeZoneId',
  VALUE: 'value',
  LABEL: 'label'
}

export const NOTIFICATION_CHANNEL_ENTITY_KEYS = {
  VALUE: 'value',
  ID: 'id',
  LABEL: 'label',
  DISABLED: 'disabled',
  TYPE_ID: 'typeId',
  ATTRIBUTES: 'attributes',
  ENABLED_BY_DEFAULT: 'enabledByDefault',
  TRACKING_LABEL: 'trackingLabel',
  ICON: 'icon'
}

export const DAYS_OF_WEEK_ENTITY_KEYS = {
  DEFAULT: 'default',
  DAY_NAME: 'dayName',
  NAME: 'name',
  VALUE: 'value'
}

export const SCHEDULE_PARTICIPANTS_ENTITY_KEYS = {
  LABEL: 'label',
  VALUE: 'value',
  STRATEGY_TYPE_ID: 'strategyTypeId',
  GROUP_IDS: 'groupIds',
  EXCLUDED_GROUP_IDS: 'excludedGroupIds',
  USER_ACCOUNT_IDS: 'userAccountIds',
  EXCLUDED_USER_ACCOUNT_IDS: 'excludedUserAccountIds'
}

export const ELEMENT_PROGRESS_ENTITY_KEYS = {
  PERIODS: 'periods'
}

export const COMMENT_ENTITY_KEYS = {
  ID: 'id',
  PARENT_ID: 'parentId',
  TEXT: 'text',
  CHILD_COMMENTS: 'childComments',
  COMMENT_ID: 'commentId',
  REACTIONS: 'reactions'
}

export const CHECKIN_ENTITY_KEYS = {
  ID: 'id',
  AUTHOR: 'author',
  PERMISSIONS: 'permissions',
  PARAMETER_ID: 'parameterId',
  TO: 'to',
  FROM: 'from',
  ARROW: 'arrow',
  VALUE: 'value',
  COLOR: 'color',
  COMMENT: 'comment',
  COMMENTS: 'comments',
  NEW_VALUE: 'newValue',
  NEW_STATUS: 'newStatus',
  OUTDATED: 'outdated',
  NAME: 'name',
  DATA: 'data',
  CHECKIN_DATE: 'checkinDate',
  IS_STARTED: 'isStarted',
  LOCAL_CONFIDENCE_LEVEL_ID: 'localConfidenceLevelId',
  LOCAL_AUTOMATIC_CONFIDENCE_LEVEL_ID: 'localAutomaticConfidenceLevelId',
  LOCAL_CURRENT_VALUE: 'localCurrentValue',
  LOCAL_GRADE_VALUE: 'localGradeValue',
  BACKDATE: 'backdate',
  CLOSE_NESTED_ELEMENTS: 'closeNestedElements',
  UPDATE_STATUS_FOR_NESTED_ELEMENTS: 'updateStatusForNestedElements',
  LABEL: 'label',
  CREATE_LABEL: 'createLabel',
  VIEW_LABEL: 'viewLabel',
  TOOLTIP: 'tooltip'
}

export const CHECKIN_TEMPLATE_ENTITY_KEYS = {
  ID: 'id',
  TITLE: 'title',
  EMOJI: 'emoji',
  WORKSPACE_IDS: 'workspaceIds',
  ADD_TO_ALL_WORKSPACES: 'addToAllWorkspaces',
  TEXT: 'text',
  WORKSPACES: 'workspaces'
}

export const ORGANIZATION_ENTITY_KEYS = {
  NAME: 'name',
  ID: 'id',
  ISS: 'iss'
}

export const ALERT_ENTITY_KEYS = {
  ID: 'id',
  NAME: 'name',
  DISPLAY_NAME: 'displayName',
  TYPE_ID: 'typeId'
}

export const SAML_CONNECTION_ENTITY_KEYS = {
  STATUS_ID: 'statusId',
  PROTOCOL: 'protocol',
  PROVIDER: 'provider',
  DOMAINS: 'domains',
  NAME: 'name',
  ID: 'id',
  CREATED_DATE: 'createdDate'
}

export const SAML_DOMAIN_ENTITY_KEYS = {
  ID: 'id',
  DOMAIN_NAME: 'domainName',
  STATUS_ID: 'statusId',
  IS_VALID: 'isValid',
  IS_UNIQUE: 'isUnique'
}

export const SCIM_CONNECTION_ENTITY_KEYS = {
  ...SAML_CONNECTION_ENTITY_KEYS
}
